import { Injectable } from '@angular/core';
import { AlertProp, ToastComponent } from 'src/app/components/inside/utils/toast/toast.component';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toastComponent: ToastComponent | undefined;

  constructor() { }

  setToastComponent(toastComponent : ToastComponent){
    this.toastComponent = toastComponent;
  }

  /**
   * Creazioen alert con autoHide: true e delay a 3 sec. (Default)
   * @param title 
   * @param valClass 
   */
  openToast(title: string, valClass: string){
    let alert: AlertProp = {autoHidde: true, delay: 3000, title: title, valClass: valClass, view: true};
    this.toastComponent!.addAlert(alert);
  }

  /**
   * Creazione alert co tutti i parametri
   * @param autoHidde 
   * @param delay 
   * @param title 
   * @param valClass 
   */
  openToastWithConfig(autoHidde: boolean, delay: number, title: string, valClass: string){
    let alert: AlertProp = {autoHidde: autoHidde, delay: delay, title: title, valClass: valClass, view: true};
    this.toastComponent!.addAlert(alert);
  }

}
